import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../../../../../media';

export const CategoriesWrapper = styled.div`
	display: grid;
	grid-auto-rows: 384px;
	grid-template-columns: repeat(auto-fit, 280px);
	margin-top: 32px;
	column-gap: 24px;
	row-gap: 32px;
	${media.tablet} {
		margin-top: 16px;

		@media (width >= 768px) {
			grid-auto-rows: 300px;
			grid-template-columns: repeat(auto-fit, 212px);
			column-gap: 12px;
		}
	}
	${media.mobile} {
		grid-auto-rows: 113px;
		grid-template-columns: 1fr;
	}
`;

export const CardsStyles = css`
	width: 100%;
	height: 100%;
`;
